<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.campaignReport')" :title="$t('nav.campaignReport')">
      <div class="list__buttons"></div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__top-red-text">
        {{ $t("report.campaignHint") }}
      </div>
      <div class="list__filter">
        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('languages', [])"
              v-if="filterData.languages.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.languages.length > 0">
                  {{ filterData.languages[0].code }}

                  <template v-if="filterData.languages.length > 1">
                    +{{ filterData.languages.length - 1 }}
                  </template>
                </template>
                <template v-else> Languages </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_languages" placeholder="Search Languages" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.languages"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('languages', item)"
                  >
                    {{ item.code }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('languages', item)"
                  v-for="item in getCheckList(
                    'languagesList',
                    'search_languages',
                    'code',
                    'languages',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.code }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('direction', [])"
              v-if="filterData.direction.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.direction.length > 0">
                  {{ filterData.direction[0].name }}

                  <template v-if="filterData.direction.length > 1">
                    +{{ filterData.direction.length - 1 }}
                  </template>
                </template>
                <template v-else> Direction </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.direction"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('direction', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('direction', item)"
                  v-for="item in directionList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('integration_type', [])"
              v-if="filterData.integration_type.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.integration_type.length > 0">
                  {{ filterData.integration_type[0].name }}

                  <template v-if="filterData.integration_type.length > 1">
                    +{{ filterData.integration_type.length - 1 }}
                  </template>
                </template>
                <template v-else> {{ $t("report.integrationType") }} </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.integration_type"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('integration_type', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('integration_type', item)"
                  v-for="item in integrationTypeList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!bayer" class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('bayer', [])"
              v-if="filterData.bayer.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.bayer.length > 0">
                  {{ filterData.bayer[0].email }}

                  <template v-if="filterData.bayer.length > 1">
                    +{{ filterData.bayer.length - 1 }}
                  </template>
                </template>
                <template v-else> Bayer </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_bayer" placeholder="Search Bayer" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.bayer"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('bayer', item)"
                  >
                    {{ item.email }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('bayer', item)"
                  v-for="item in getCheckList('bayerList', 'search_bayer', 'email', 'bayer')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.email }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!bayer" class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('team', [])"
              v-if="filterData.team.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.team.length > 0">
                  {{ filterData.team[0].name }}

                  <template v-if="filterData.team.length > 1">
                    +{{ filterData.team.length - 1 }}
                  </template>
                </template>
                <template v-else> Team </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_team" placeholder="Search Team" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.team"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('team', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('team', item)"
                  v-for="item in getCheckList('teamList', 'search_team', 'name', 'team')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('type', [])"
              v-if="filterData.type.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.type.length > 0">
                  {{ filterData.type[0].name }}

                  <template v-if="filterData.type.length > 1">
                    +{{ filterData.type.length - 1 }}
                  </template>
                </template>
                <template v-else> Type Integration </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.type"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('type', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('type', item)"
                  v-for="item in typeList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('integration', [])"
              v-if="filterData.integration.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.integration.length > 0">
                  {{ filterData.integration[0].name }}

                  <template v-if="filterData.integration.length > 1">
                    +{{ filterData.integration.length - 1 }}
                  </template>
                </template>
                <template v-else> Integrations </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_integration" placeholder="Search Integration" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.integration"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('integration', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('integration', item)"
                  v-for="item in getCheckList(
                    'integrationList',
                    'search_integration',
                    'name',
                    'integration',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <b>from: </b>
          <DatePicker v-model="filterData.date_from" :format="'DD.MM.YYYY'" />
        </div>

        <div class="list__filter-item">
          <b>to: </b>
          <DatePicker v-model="filterData.date_to" :format="'DD.MM.YYYY'" />
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="exportLead()">Export</MainButton>
        </div>
        <div class="list__filter-item">Count: {{ list.length }}</div>
      </div>

      <div class="list">
        <div v-if="list.length">
          <CustomTable
            v-if="list.length"
            :data="list"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :order="orderSort"
            :noSortColumn="tableOptions.noSortColumn"
            :name="'buyerDeposit'"
          >
            <template v-slot:extra>
              <div class="custom-table__row row-total total">
                <div class="custom-table__row-item">{{ statistics.integrations }}</div>
                <div class="custom-table__row-item">{{ statistics.count_by_deposit }}</div>
                <div class="custom-table__row-item">{{ statistics.count_by_succeed }}</div>
                <div class="custom-table__row-item">{{ statistics.cr }}</div>
                <div class="custom-table__row-item">{{ statistics.cr_mtm }}</div>
                <div class="custom-table__row-item">{{ statistics.ftd }}</div>
                <div class="custom-table__row-item">{{ statistics.ftd_mtm }}</div>
              </div>
            </template>
          </CustomTable>
        </div>
        <div class="list__no-have" v-else>No History found by this parameter.</div>
      </div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import userApi from "~/api/user";
import moment from "moment";
import { getStoredUserInfo } from "~/helpers/userAuth";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainSelect from "~/components/atoms/inputs/MainSelect.vue";

export default {
  name: "CompaignReport",
  metaInfo: {
    title: "Compaign Report",
  },
  data() {
    return {
      list: [],
      data: {},
      statistics: {},
      directionSort: false,
      orderSort: "count_by_succeed",

      search_integration: "",
      search_client: "",
      search_countries: "",
      search_languages: "",
      search_bayer: "",
      search_team: "",

      filterData: {
        date_from: null,
        date_to: null,
        languages: [],
        direction: [],
        type: [],
        integration_type: [],
        integration: [],
        bayer: [],
        team: [],
      },
      isFilter: false,
      clientList: [],
      integrationList: [],
      countriesList: [],
      languagesList: [],
      bayerList: [],
      teamList: [],

      tableOptions: {
        deletedKeys: ["null"],
        isActionBlockVisible: true,
        noSortColumn: ["name", "count_by_deposit", "count_by_succeed"],
        renameColumn: [
          {
            from: "name",
            to: "Name",
          },
          {
            from: "count_by_deposit",
            to: "Count By Deposit",
          },
          {
            from: "count_by_succeed",
            to: "Count By Succeed",
          },
          {
            from: "cr",
            to: "CR",
          },
          {
            from: "cr_mtm",
            to: "CR Mtm",
          },
          {
            from: "ftd",
            to: "FTD",
          },
          {
            from: "ftd_mtm",
            to: "FTD Mtm",
          },
        ],
        customOrder: [
          "name",
          "count_by_deposit",
          "count_by_succeed",
          "cr",
          "cr_mtm",
          "ftd",
          "ftd_mtm",
        ],
      },

      directionList: [
        {
          name: this.$t("region.europe"),
          id: "eu",
        },
        {
          name: this.$t("region.australia"),
          id: "au",
        },
        {
          name: this.$t("region.canada"),
          id: "ca",
        },
      ],

      typeList: [
        {
          name: "CPA",
          id: "CPA",
        },
        {
          name: "CPL",
          id: "CPL",
        },
      ],

      integrationTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "In",
          id: "in",
        },
        {
          name: "Out",
          id: "out",
        },
      ],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    // Pagination,
    ModalError,
    // MainSelect,
    DatePicker,
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    window.addEventListener("keydown", this.onKeyDown);
    this.getLanguage();
    this.setQueryParams();
    this.getIntegration();

    // Баеру списки баеров/команд недоступны, фильтры по ним скрыты
    if (!this.bayer) {
      this.getBayer();
      this.getTeam();
    }
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess"]),
    page() {
      return +this.$route.params.page;
    },
    bayer() {
      const user = getStoredUserInfo();
      return !!user && user.groups[0].id == 3;
    },
    getQueryParameters() {
      const query = this.$route.fullPath.split("?")[1];
      if (query) {
        return `?${query}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    async getBayer() {
      await userApi
        .getBayerAll()
        .then((res) => {
          this.bayerList = res.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getTeam() {
      await userApi
        .getTeamAll()
        .then((res) => {
          this.teamList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    onKeyDown(e) {
      if (e.key === "Enter") {
        this.filterList();
      }
    },
    getCheckList(listKey, filterKey, nameKey, chooseItem) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      // список выбранных id
      const selectedIds = Array.isArray(this.filterData[chooseItem])
        ? this.filterData[chooseItem].map((item) => item?.id)
        : [];

      const filterStr =
        rawFilter == null || String(rawFilter).trim() === ""
          ? null
          : String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        // ❌ исключаем если id уже выбран
        if (selectedIds.includes(item?.id)) return false;

        // если фильтра нет — возвращаем всё кроме выбранных
        if (!filterStr) return true;

        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    async getIntegration() {
      await leadApi
        .getIntegrationAll()
        .then((res) => {
          this.integrationList = res.data;
          console.log(this.clientList);
        })
        .catch((error) => {})
        .finally(() => {});
    },
    getList() {
      let url = ``;
      if (this.orderSort.length) {
        url = url + `?sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }

      const data = {
        parameters: {},
      };

      if (this.filterData.integration.length > 0) {
        const ids = this.filterData.integration;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.integration_id = idsArray;
      }

      if (this.filterData.languages.length > 0) {
        const ids = this.filterData.languages;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.language_id = idsArray;
      }

      if (this.filterData.direction.length > 0) {
        const ids = this.filterData.direction;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.direction = idsArray;
      }

      if (this.filterData.integration_type.length > 0) {
        const ids = this.filterData.integration_type;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.integration_type = idsArray;
      }

      if (this.filterData.bayer.length > 0) {
        const ids = this.filterData.bayer;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.buyer_id = idsArray;
      }

      if (this.filterData.team.length > 0) {
        const ids = this.filterData.team;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.team_id = idsArray;
      }

      if (this.filterData.type.length > 0) {
        const ids = this.filterData.type;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.integrationType = idsArray;
      }

      if (this.filterData.date_from || this.filterData.date_to) {
        if (this.filterData.date_from) {
          data.parameters.created_at_from = moment(this.filterData.date_from).format("YYYY-MM-DD");
        }

        if (this.filterData.date_to) {
          data.parameters.created_at_to = moment(this.filterData.date_to).format("YYYY-MM-DD");
        }
      } else {
        data.parameters.created_at_from = moment().startOf("month").format("YYYY-MM-DD");
        data.parameters.created_at_to = moment().format("YYYY-MM-DD");
      }

      this.$store.commit("lead/setLoading", true);

      leadApi
        .getCompaignReport(url, data)
        .then((res) => {
          this.$store.commit("lead/setError", {});
          this.$store.commit("lead/setValidationErrors", {});

          const resItems = res.data.items;
          const itemsArray = [];

          const key = Object.keys(resItems);
          const value = Object.values(resItems);
          key.forEach((item, index) => {
            const elem = {
              name: item,
              count_by_deposit: value[index].count_by_deposit,
              count_by_succeed: value[index].count_by_succeed,
              cr: value[index].cr,
              cr_mtm: value[index].cr_mtm,
              ftd: value[index].ftd,
              ftd_mtm: value[index].ftd_mtm,
            };
            itemsArray.push(elem);
          });

          this.list = itemsArray;
          this.statistics = res.data.statistic;
          console.log(this.list);
        })
        .catch((error) => {
          const { data } = error.response;
          console.log(error);
          this.$store.commit("lead/setError", data);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },

    async getLanguage() {
      await leadApi
        .getLanguageList()
        .then((res) => {
          this.languagesList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    filterList() {
      this.isFilter = true;
      this.handleSetQueryParams();
    },

    handleSetQueryParams() {
      const filter = {};

      if (this.filterData.integration.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.integration.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.integration = ids.join(",");
        filter.integration_name = name.join(",");
      }

      if (this.filterData.languages.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.languages.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.code);
        });

        filter.languages = ids.join(",");
        filter.languages_name = name.join(",");
      }

      if (this.filterData.direction.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.direction.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.direction = ids.join(",");
        filter.direction_name = name.join(",");
      }

      if (this.filterData.integration_type.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.integration_type.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.integration_type = ids.join(",");
        filter.integration_type_name = name.join(",");
      }

      if (this.filterData.bayer.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.bayer.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.email);
        });

        filter.bayer = ids.join(",");
        filter.bayer_name = name.join(",");
      }

      if (this.filterData.team.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.team.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.team = ids.join(",");
        filter.team_name = name.join(",");
      }

      if (this.filterData.type.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.type.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.type = ids.join(",");
        filter.type_name = name.join(",");
      }

      if (this.filterData.date_from != null) {
        filter.date_from = moment(this.filterData.date_from).format("YYYY-MM-DD");
      }

      if (this.filterData.date_to != null) {
        filter.date_to = moment(this.filterData.date_to).format("YYYY-MM-DD");
      }

      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.COMPAIGN_REPORT.replace(":page", 1),
        });
      }
      this.$router.push({ name: "CompaignReport", query: filter });
    },
    setQueryParams() {
      if (this.handleGetQueryParam("languages")) {
        const ids = this.handleGetQueryParam("languages").split(",");
        const names = this.handleGetQueryParam("languages_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.languages.push({
            id: ids[index],
            code: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("integration")) {
        const ids = this.handleGetQueryParam("integration").split(",");
        const names = this.handleGetQueryParam("integration_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.integration.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("direction")) {
        const ids = this.handleGetQueryParam("direction").split(",");
        const names = this.handleGetQueryParam("direction_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.direction.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("integration_type")) {
        const ids = this.handleGetQueryParam("integration_type").split(",");
        const names = this.handleGetQueryParam("integration_type_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.integration_type.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("bayer")) {
        const ids = this.handleGetQueryParam("bayer").split(",");
        const names = this.handleGetQueryParam("bayer_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.bayer.push({
            id: ids[index],
            email: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("team")) {
        const ids = this.handleGetQueryParam("team").split(",");
        const names = this.handleGetQueryParam("team_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.team.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("type")) {
        const ids = this.handleGetQueryParam("type").split(",");
        const names = this.handleGetQueryParam("type_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.type.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("date_from")) {
        this.filterData.date_from = moment(
          this.handleGetQueryParam("date_from"),
          "YYYY-MM-DD",
        ).toDate();
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("date_to")) {
        this.filterData.date_to = moment(
          this.handleGetQueryParam("date_to"),
          "YYYY-MM-DD",
        ).toDate();
        this.isFilter = true;
      }

      this.getList();
    },
    handleGetQueryParam(param) {
      if (this.$route.query[param] != undefined) {
        return this.$route.query[param];
      } else {
        return null;
      }
    },

    filterListReset() {
      this.isFilter = false;
      this.$router.push({ name: "CompaignReport", query: {} });
      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.COMPAIGN_REPORT.replace(":page", 1),
        });
      }
      this.filterData.date_from = null;
      this.filterData.date_to = null;
      this.filterData.languages = [];
      this.filterData.direction = [];
      this.filterData.type = [];
      this.filterData.integration = [];
      this.filterData.integration_type = [];
      this.filterData.bayer = [];
      this.filterData.team = [];

      this.getList();
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },

    addCheckElement(key, value) {
      const foundObj = this.filterData[key].find((obj) => obj.id === value.id);
      if (foundObj == undefined) {
        this.filterData[key].push(value);
      }
    },
    removeCheckElement(key, value) {
      this.filterData[key] = this.filterData[key].filter((obj) => obj.id !== value.id);
    },
    resetCheck(key, reset) {
      console.log("hello");
      this.filterData[key] = reset;
    },

    exportLead(success = false) {
      this.$store.commit("lead/setLoading", true);
      let url = ``;
      if (this.orderSort.length) {
        url = url + `?sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }

      const data = {
        parameters: {},
      };

      if (this.filterData.languages.length > 0) {
        const ids = this.filterData.languages;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.language_id = idsArray;
      }

      if (this.filterData.direction.length > 0) {
        const ids = this.filterData.direction;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.direction = idsArray;
      }

      if (this.filterData.integration_type.length > 0) {
        const ids = this.filterData.integration_type;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.integration_type = idsArray;
      }

      if (this.filterData.bayer.length > 0) {
        const ids = this.filterData.bayer;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.bayer_id = idsArray;
      }

      if (this.filterData.team.length > 0) {
        const ids = this.filterData.team;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.team_id = idsArray;
      }

      if (this.filterData.type.length > 0) {
        const ids = this.filterData.type;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.integrationType = idsArray;
      }

      if (this.filterData.date_from || this.filterData.date_to) {
        if (this.filterData.date_from) {
          data.parameters.created_at_from = moment(this.filterData.date_from).format("YYYY-MM-DD");
        }

        if (this.filterData.date_to) {
          data.parameters.created_at_to = moment(this.filterData.date_to).format("YYYY-MM-DD");
        }
      } else {
        data.parameters.created_at_from = moment().startOf("month").format("YYYY-MM-DD");
        data.parameters.created_at_to = moment().format("YYYY-MM-DD");
      }

      leadApi
        .exportCompaignReport(data, url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.check-selector {
  position: relative;

  &__reset {
    position: absolute;
    left: 5px;
    cursor: pointer;
    top: 9px;
    z-index: 11;
  }

  &__list {
    display: none;
    position: absolute;
    top: calc(100% - 20px);
    left: -100px;
    min-width: calc(300px + 40px);
    max-width: 400px;
    max-height: 340px;
    z-index: 10;
    padding: 20px;
  }

  &__list-container {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #3c2a1e;
    background: #fff;
    overflow-y: auto;
    max-height: 300px;
  }

  &__button {
    width: 170px;
    padding: 5px 5px 5px 30px;
    border: 1px solid #3c2a1e;
    border-radius: 5px;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  &__button-name {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__list-item {
    padding: 5px 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
      background: #c7c3c0;
    }

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3c2a1e;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      border-radius: 50px;
      line-height: 1;
    }
  }

  &__check-items {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #3c2a1e;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  &__check-item {
    padding: 5px;
    border-radius: 5px;
    background: #3c2a1e;
    color: #fff;
    margin: 0 5px 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 15px;
      font-weight: 700;
      color: #3c2a1e;
      border-radius: 50px;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &:hover {
    .check-selector__list {
      display: block !important;
    }
  }

  &:focus-within {
    .check-selector__list {
      display: block !important;
    }
  }
}
/deep/.custom-table__header,
/deep/.custom-table__row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr !important;
}

/deep/.modal-container {
  height: fit-content;
  max-height: 90vh;
  overflow-y: auto;
}

.list {
  &__top-red-text {
    font-size: 20px;
    font-weight: 600;
    color: rgb(161, 5, 5);
  }
  &__filter-favorite {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    font-size: 18px;
    cursor: pointer;

    svg {
      margin-left: 5px;
    }

    .inner {
      fill: #fff !important;
    }
    .border {
      stroke: rgb(148, 22, 22) !important;
      fill: none !important;
    }

    &.active {
      .inner {
        fill: rgb(148, 22, 22) !important;
      }
    }
  }
  &__confirm-log {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid gainsboro;
    margin-bottom: 10px;
  }

  &__confirm-log-type {
    padding: 20px;
    background: gainsboro;
    border-radius: 10px;
    margin-right: 10px;
  }

  &__confirm-log-time {
    margin-left: auto;
    padding-left: 10px;
  }

  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 170px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }
}
</style>
